const lang = {
  msgsaved: "Data Saved",
  email: "Email",
  email_or_username: "Email or username",
  actions: "Actions",
  export: "Export",
  picture: "Picture",
  title: "title",
  created: "Created Date",
  previous: "Previous",
  next: "Next",
  edit: "Edit",
  delete: "Delete",
  page: "Page",
  loading: "Loading",
  order: "Order",
  event: "Event",
  date: "Date",
  day: "Day",
  paid: "Paid",
  amount: "Amount",
  invoicedate: "Invoice Date",
  invoicenumber: "Invoice Number",
  profilepicture: "Profile Picture",
  phone: "Phone",
  name: "Name",
  username: "Username",
  type: "Type",
  note: "Note",
  pendingpayment: "Pending Payment",
  amounttype: "Amount Type",
  information: "Information",
  save: "Save",
  select: "Select",
  address: "Address",
  fromtime: "From Time",
  totime: "To Time",
  accounttype: "Account Type",
  paymenttype: "Payment Type",
  paymentamounttype: "Payment Amount Type",
  time: "Time",
  csv: "CSV",
  message: "Message",
  fullname: "Full Name",
  password: "Password",
  registred: "Registered At",
  dob: "Birthday",
  registration: "Registration",
  nationality: "Nationality",
  sex: "Sex",
  firstname: "First Name",
  lastname: "Last Name",
  report: "Report",
  add: "Add",
  home: "Home",
  lang: "English",
  news: "News",
  managergmgnet: "Administration",
  banner: "Logo",
  book: "Library",
  uni: "University",
  cal: "Calendar",
  department: "Department",
  section: "Section",
  fees: "Fees",
  feestype: "Fees Type",
  classx: "Classes",
  agenda: "Agenda",
  uploadx: "Upload Files",
  notx: "Notifications",
  maangx: "Manager",
  managtype: "Manager Type",
  cities: "Cities",
  client: "Client",
  branch: "Branch",
  offer: "Offer",
  items: "Items",
  subitems: "Subitems",
  jobs: "Jobs",
  service: "Service",
  baner: "Banner",
  customeruser: "Customer User",
  customervehicle: "Customer Vehicle",
  statusreason: "Status Reason",
  appointmentThreshold: "Appointment Threshold",
  fromToHours: "From-To Hours",
  minimumyear: "Minimum Year",
  maxyear: "Maximum Year",
  recipient: "Recipient",
  template: "Template",
  notification: "Notification",
  link: "Link",
  city: "City",
  country: "Country",
  make: "Make",
  model: "Model",
  trim: "Trim",
  platecode: "Plate Code",
  energytype: "Energy Type",
  platenumber: "Plate Number",
  vin: "VIN",
  latitude: "Latitude",
  longitude: "Longitude",
  scope: "Scope",
  manager: "Manager",
  code: "Code",
  customer: "Customer",
  vehicle: "Vehicle",
  arrivalmileage: "Arrival Mileage",
  worker: "Worker",
  driver: "Driver",
  driverphonenumber: "Driver Phone Number",
  images: "Images",
  workinghours: "Working Hours",
  breaktime: "Break Time",
  starttime: "Start Time",
  endtime: "End Time",
  firstday: "First Day",
  lastday: "Last Day",
  appointmentsfrequency: "Appointments Frequency",
  appointmentsperslot: "Appointments Per Slot",
  slotbookingthreshold: "Slot Booking Threshold",
  cities_management: "Cities Management",
  city_list: "City List",
  city_areas: "City Areas",
  merchants_management: "Merchants Management",
  merchant: "Merchant",
  merchant_items: "Merchant Items",
  merchant_subitems: "Merchant SubItems",
  merchant_jobs: "Merchant Jobs",
  merchant_workers: "KARAGI Staff",
  merchant_users: "Merchant Users",
  merchant_branch_details: "Merchant Branch Details",
  merchant_branches: "Merchant Branches",
  branch_services: "Branch Services",
  garage_services: "Garage Services",
  service_catalogue: "Service Catalogue",
  branch_photos: "Branch Photos",
  branch_ratings: "Branch Ratings",
  appointments_management: "Appointments Management",
  appointment_settings: "Appointment Settings",
  appointments: "Appointments",
  appointment_bookings: "Appointment Bookings",
  setup: "Setup",
  services: "Services",
  offers: "Offers",
  vehicles: "Vehicles",
  vehicles_management: "Vehicles Management",
  vehicle_makes: "Vehicle Makes",
  top_rated: "Top Rated",
  top_rated_rank: "Top Rated Rank",
  application_setup: "Application Setup",
  search_radius_km: "Search Radius (km)",
  enable_reviews: "Enable reviews in app",
  vehicle_models: "Vehicle Models",
  vehicle_model_trims: "Vehicle Model Trims",
  notifications: "Notifications",
  notifications_feed: "Notifications Feed",
  clear_notifications: "Clear notifications",
  delete_notification: "Delete notification",
  confirm_clear_notifications: "Delete all notifications?",
  banners: "Banners",
  users_management: "Users Management",
  user_list: "User List",
  customers: "Customers",
  customer_users: "Customer Users",
  customer_vehicles: "Customer Vehicles",
  add_city: "add city",
  edit_client: "edit client",
  add_merchant: "add merchant",
  edit_merchant: "edit merchant",
  add_offer: "add offer",
  edit_offer: "edit offer",
  add_merchant_items: "add Merchant items",
  edit_merchant_items: "edit Merchant items",
  add_merchant_subitems: "add Merchant subitems",
  edit_merchant_subitems: "edit Merchant subitems",
  add_merchant_jobs: "add Merchant jobs",
  edit_merchant_jobs: "edit Merchant jobs",
  add_merchant_branch_photo: "add merchant branch photo ",
  edit_merchant_branch_photo: "edit merchant branch photo",
  add_merchant_branch_appointment_settings:
    "add merchant branch appointment settings",
  edit_merchant_branch_appointment_settings:
    "edit merchant branch appointment settings",
  add_appointment_booking: "add merchant branch appointment settings",
  edit_appointment_booking: "edit merchant branch appointment settings",
  add_merchant_branch_service: "add merchant branch service ",
  edit_merchant_branch_service: "edit merchant branch service",
  add_vehicles_make: "add vehicles-make",
  edit_vehicles_make: "edit vehicles-make",
  add_vehicle_model: "add vehicle-model",
  edit_vehicle_model: "edit vehicle-model",
  add_vehicle_model_trim: "add vehicle-model_trim",
  edit_vehicle_model_trim: "edit vehicle-model_trim",
  add_notifications: "add Notifications",
  edit_notifications: "edit Notifications",
  add_services: "add Services",
  edit_services: "edit Services",
  add_areas: "add areas",
  edit_areas: "edit areas",
  add_banner: "add banner",
  edit_banner: "edit banner",
  edit_user: "edit user",
  add_user: "add user",
  add_vehicle: "add vehicle",
  edit_vehicle: "edit vehicle",
  edit_merchantbranch: "edit merchantbranch",
  add_merchantbranch: "add merchantbranch",
  edit_merchantworker: "Edit KARAGI Staff",
  add_merchantworker: "Add KARAGI Staff",
  edit_merchantuser: "edit merchantuser",
  add_merchantuser: "add merchantuser",
  login: "Login",
  logout: "Logout",
  edit_manager_type: "Edit manager type",
  add_manager_type: "add manager type",
  edit_manager: "Edit manager ",
  add_manager: "add manager ",
  manager_type: "Manager Type",
  description: "Description",
  appointment: "Appointment",
  nodata: "No data found",
  confirmdelete: "Are you sure you want to delete?",
  error: "Something went wrong. Please try again later.",
  area: "Area",
  sync: "Sync",
  year: "Year",
  yes: "Yes",
  no: "No",
  user: "User",
  workingdays: "Working Days",
  itemcode: "Item Code",
  quantity: "Quantity",
  received: "Received",
  status: "Status",
  departureMileage: "Departure Mileage",
  job: "Job",
  rate: "Rate",
  comment: "Comment",
  slotscount: "Slots Count",
  item: "Item",
  cancel: "Cancel",
  selectall: "Select All",
  scopes: "Scopes",
  selected: "Selected",
  data: "Data",
  method: "Method",
  open: "Open",
  gasoline: "Gasoline",
  diesel: "Diesel",
  electric: "Electric",
  hybrid: "Hybrid",
  occupation: "Occupation",
  subitem: "Sub Item",
  REGISTRATION: "Registration",
  INSPECTION: "Inspection",
  WAITING_FOR_APPROVAL: "Waiting for Approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  IN_PROGRESS: "In Progress",
  TEST_DRIVE: "Test Drive",
  COMPLETED: "Completed",
  allowedjobstatuses: "Allowed Job Statuses",
  saveandsendforapproval: "Save And Send For Approval",
  sendfortestdrive: "Send For Test Drive",
  sendtogarage: "Send To Garage",
  reject: "Reject",
  testdrivenote: "Test Drive Note",
  ON_HOLD: "On Hold",
  complete: "Complete",
  refresh: "Refresh",
  price: "Price",
  remark: "Remark",
  branch_service_details: "Service Details",
  add_service_detail: "Add Service Detail",
  edit_service_detail: "Edit Service Detail",
  garages: "Garages",
  garage: "Garage",
  add_garage: "Add Garage",
  search_garages: "Search by name, address, city or phone",
  no_garages: "No garages found",
  deactivate: "Deactivate",
  deactivated: "Deactivated",
  activate: "Reactivate",
  deactivated_garages: "Deactivated garages",
  deactivated_garages_subtitle: "Garages switched off — their staff and records are kept",
  back_to_active_garages: "Back to active garages",
  no_deactivated_garages: "No deactivated garages",
  confirm_deactivate_garage: "Deactivate {0}? It disappears from the app and takes no new work. Its staff, job cards and history are kept, and you can reactivate it later.",
  confirm_activate_garage: "Reactivate {0}? It goes back into the app and can take work again.",
  back_to_garages: "Back to Garages",
  select_merchant_first: "Select a merchant to view its garages",
  photos: "Photos",
  ratings: "Ratings",
  manage: "Manage",
  cards_view: "Cards",
  table_view: "Table",
  garage_count: "garage(s)",
  location: "Location",
  search_location: "Search an address or place",
  use_my_location: "Use my current location",
  map_hint: "Click on the map or drag the marker to set the garage location",
  garage_address_hint: "Address is required (at least 10 characters)",
  garage_location_hint: "Pick the garage location on the map",
  photos_after_save_hint: "Photos are uploaded once the garage is saved",
  required_hint: "This field is required",
  name_min_hint: "Name must be at least 2 characters",
  price_min_hint: "Price cannot be negative",
  hours_required_hint: "Set both the start and the end time",
  threshold_min_hint: "Minimum 4",
  frequency_hint: "Minutes between two appointment slots",
  branch_service_form_hint: "Pick the service this garage offers",
  photo_required_hint: "Choose at least one picture",
  photo_replace_hint: "Choose a picture to replace the current one",
  photo_multi_hint: "You can select several pictures at once",
  name_min3_hint: "Name must be at least 3 characters",
  roles: "Roles",
  roles_subtitle: "Permission templates for logins",
  user_access_subtitle: "Who can see and change what",
  garages_subtitle: "Every workshop of this merchant",
  role: "Role",
  add_role: "Add Role",
  permissions: "Permissions",
  permissions_required_hint: "Select at least one permission",
  default_for_garages: "Default for garages",
  default_for_garages_hint:
    "New garage logins start with the permissions of this role",
  search_permissions: "Search permissions",
  clear_all: "Clear all",
  select_all: "Select all",
  all_selected: "All selected",
  can_view: "View",
  can_edit: "Edit",
  user_access: "User Access",
  add_user_access: "Add User",
  edit_access: "Edit access",
  access: "Access",
  all_garages: "All garages",
  role_prefill_hint: "Picking a role fills the permissions below",
  garage_pin_hint: "Limit this user to a single garage",
  garage_login: "Garage Login",
  garage_login_hint: "The garage signs in with this email",
  garage_role_hint: "Permissions given to this garage login",
  new_password: "New password",
  password_hint:
    "At least 8 characters with upper case, lower case, a number and a symbol",
  password_change_hint: "Leave empty to keep the current password",
  email_hint: "Enter a valid email address",
  phone_min_hint: "Phone number must be at least 8 digits",
  work_orders: "Work Orders",
  work_tracking: "Work Tracking",
  mark_all_read: "Mark all read",
  payment_methods: "Payment Methods",
  payment_method: "Payment Method",
  payment_methods_subtitle: "Fixed system list — turn a method on or off for garages to accept",
  active: "Active",
  garage_setup: "Garage Setup",
  no_garage_setup: "This garage isn't set up yet",
  no_garage_setup_hint: "Configure the currency, VAT, delivery-date colors and accepted payment methods",
  vat: "VAT",
  has_vat: "This garage charges VAT",
  vat_percentage: "VAT Percentage",
  vat_percentage_hint: "Required when VAT is enabled",
  delivery_colors: "Delivery Date Colors",
  delivery_colors_hint: "Hours remaining before the delivery time at which each color starts to show. The most urgent color that applies wins.",
  green_threshold_hours: "Green — hours before delivery",
  yellow_threshold_hours: "Yellow — hours before delivery",
  red_threshold_hours: "Red — hours before delivery",
  accepted_payment_methods: "Accepted Payment Methods",
  currencies: "Currencies",
  currency: "Currency",
  currencies_subtitle: "The currencies garages price in — add one and it becomes pickable in Garage Setup",
  add_currency: "Add Currency",
  delivery_methods: "Delivery Methods",
  delivery_method: "Delivery Method",
  delivery_methods_subtitle: "How a car arrives at a garage — the job card offers the active ones",
  add_delivery_method: "Add Delivery Method",
  delivery_method_name_hint: "Shown to the worker as-is, e.g. Recovery",
  delivery_method_active_hint: "Inactive methods stay on old job cards but are no longer offered",
  display_order: "Display Order",
  display_order_hint: "Lower shows first",
  delivery_method_asks_for: "Asks for",
  delivery_method_asks_for_hint: "What to record when a car arrives or leaves this way",
  asks_nothing: "Nothing",
  asks_person: "A driver's name and phone",
  asks_company: "A company's name",
  driver_name: "Driver's name",
  driver_phone: "Driver's phone",
  recovery_company: "Recovery company",
  required_field: "Required",
  fuel_level: "Fuel level",
  delivery_method_hint: "How the car arrived at the garage",
  no_delivery_methods_hint: "No delivery methods are active — add them under Setup",
  how_is_car_leaving: "Car to be collected by",
  collection_method_hint: "Who takes the car away — the same choices as on arrival",
  arrived_by: "Arrived by: {0}",
  collected_by: "Collected by: {0}",
  job_card_video: "Walk-around video",
  job_card_video_hint: "Required — a short clip around the car, up to 30 seconds",
  job_card_video_required: "Add the walk-around video to open the job card",
  job_card_video_too_big: "That video is too large — keep it under 64 MB",
  job_card_photos_hint: "Optional",
  add_video: "Add video",
  add_photos: "Add photos",
  job_card_media_failed: "The job card was opened, but {0} file(s) did not upload. They can be added from the app.",
  go_to_job_cards: "Go to job cards",
  staff_tiers: "Staff Tiers",
  staff_tiers_hint: "The pay bands of this garage and what each costs an hour. Each staff member is placed on one.",
  tier: "Tier",
  tier_name: "Tier name",
  tier_name_hint: "e.g. Tier 1 or Senior",
  tier_name_required: "Give the tier a name",
  tier_rate_hint: "Enter an hourly rate of 0 or more",
  hourly_rate: "Hourly rate",
  per_hour: "/ hour",
  add_tier: "Add Tier",
  no_tiers: "No tiers yet",
  no_tiers_hint: "Add the tiers your staff are paid at, with an hourly rate for each.",
  confirm_remove_tier: "Remove this tier? Staff on it will be left without a tier.",
  role_and_tier: "Role & Tier",
  staff_role: "Role",
  role_owner: "Owner",
  role_manager: "Manager",
  role_mechanic: "Mechanic",
  role_owner_hint: "Runs the garage: receives cars, prices and approves work, hands cars over. Signs in to the garage panel and the app with the username or phone number and password above.",
  role_manager_hint: "Receives cars, sends mechanics to inspect, approves work and hands cars over; prices work if the Owner allows it. Signs in to the garage panel and the app.",
  role_mechanic_hint: "Inspects cars and does the work on their own tasks. Signs in to the app only.",
  managers_can_price: "Managers may open work orders and set prices",
  managers_can_price_hint: "Off: only the Owner prices work orders and sends quotes",
  no_tier: "No tier",
  no_tiers_for_staff_hint: "Add tiers in Garage Setup to place staff on one",
  staff_tier: "Tier",
  vehicle_specs: "Vehicle Specs",
  vehicle_spec: "Vehicle Spec",
  vehicle_specs_subtitle: "The specs a client picks from when adding a car, e.g. GCC or American",
  add_vehicle_spec: "Add Spec",
  vehicle_spec_name_hint: "Shown to clients as-is, e.g. GCC",
  vehicle_spec_active_hint: "Inactive specs stay on existing cars but are no longer offered",
  currency_symbol: "Symbol",
  currency_code_hint: "Short identifier, e.g. USD or AED",
  currency_symbol_hint: "Printed next to an amount, e.g. $",
  currency_code_min_hint: "Code must be at least 2 characters",
  currency_symbol_required_hint: "Symbol is required",
  garage_currency_hint: "New garages start on US Dollar",
  delivery: "Delivery",
  top_rated_hint: "Show this garage in the top rated list",
  top_rated_rank_hint: "Lower shows first. Leave blank to order by rating.",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  items_per_page: "Items per page:",
  of: "of",
  first_page: "First page",
  last_page: "Last page",
  pw_length: "8+ characters",
  pw_upper: "1 upper case",
  pw_lower: "1 lower case",
  pw_number: "1 number",
  pw_symbol: "1 symbol",
  phone_hint: "Enter a valid phone number",
  phone_unique_hint: "Must be unique across garages",
  version_conflict_hint: "This garage changed since you opened it. Press Save again to apply your changes.",
  job_cards: "Job Cards",
  job_card: "Job Card",
  job_cards_subtitle: "Vehicles received at this garage",
  no_job_cards: "No job cards yet",
  no_closed_job_cards: "No closed job cards yet",
  job_cards_history: "History",
  job_cards_history_subtitle: "Job cards already closed, newest first",
  select_garage_first: "Select a garage to see its job cards",
  job_card_open: "Open",
  job_card_in_progress: "In progress",
  job_card_closed: "Closed",
  dashboard: "Dashboard",
  dashboard_hint: "Everything across your garages",
  dashboard_garage_hint: "Everything about your garage",
  job_cards_by_status: "Job cards by status",
  job_cards_open_hint: "still open",
  upcoming_appointments: "Upcoming appointments",
  upcoming_hint: "upcoming",
  appointments_by_status: "Appointments by status",
  no_appointments: "No appointments yet",
  pending_hint: "waiting on you",
  booking_pending: "Pending",
  booking_accepted: "Accepted",
  booking_started: "In progress",
  booking_finished: "Finished",
  booking_rejected: "Rejected",
  booking_expired: "Expired",
  recent_job_cards: "Recent job cards",
  ratings_hint: "ratings",
  occupation_hint: "Occupation must be at least 3 characters",
  worker_password_hint: "At least 6 characters",
  worker_garage_hint: "This worker belongs to this garage",
  access_app: "App Access",
  access_app_hint: "Allow this staff member to sign in to the mobile app",
  login_username: "Username",
  worker_username_hint:
    "Optional. The staff member can sign in with this instead of the phone number",
  username_format_hint:
    "3 to 30 characters: letters, numbers, dot, underscore or dash",
  appointment_detail: "Car & customer",
  appointment_delete_booked:
    "This slot has bookings and cannot be deleted",
  cancel_bookings: "Cancel the bookings on this slot",
  confirm_cancel_bookings:
    "Cancel {0} booking(s) on this slot? The customers are notified.",
  no_bookings_to_cancel:
    "No booking on this slot can be cancelled any more",
  previous_work_orders: "Previous work orders",
  no_previous_work_orders: "No previous visits for this car",
  no_bookings: "No booking on this appointment",
  no_bookings_hint: "Nobody has booked this slot yet",
  booking_pending: "Pending",
  booking_accepted: "Accepted",
  booking_started: "In progress",
  booking_finished: "Finished",
  booking_rejected: "Rejected",
  booking_action_accept: "Accept",
  booking_action_reject: "Reject",
  booking_action_start: "Start service",
  booking_action_finish: "Finish",
  reject_reason_prompt: "Why is this booking rejected? The customer sees this.",
  day_previous: "Previous day",
  day_next: "Next day",
  day_today: "Today",
  dashboard_day_hint: "Today at this garage, plus every appointment still ahead of it",
  overview: "OVERVIEW",
  minimize: "Minimize",
  expand: "Expand",
  q_pending_appointments: "Pending appointments",
  q_pending_appointments_hint: "waiting on you, any day",
  q_accepted_appointments: "Accepted appointments",
  q_accepted_appointments_hint: "confirmed, today and ahead",
  q_open_job_cards: "Open job cards",
  q_open_job_cards_hint: "card still open",
  q_awaiting_approval: "Awaiting approval",
  q_awaiting_approval_hint: "quoted",
  q_in_progress_job_cards: "In progress",
  q_in_progress_job_cards_hint: "work order started",
  q_unpaid: "Unpaid",
  q_unpaid_hint: "invoice outstanding",
  q_ready_to_deliver: "Ready to deliver",
  q_ready_to_deliver_hint: "car waiting for its owner",
  q_delivered: "Delivered",
  q_delivered_hint: "handed back today",
  queue_empty: "Nothing in this queue",
  queue_empty_hint: "Pick another queue above",
  no_work_order: "No work order",
  no_work_order_for_card: "This job card has no work order to open.",
  walk_in: "Walk-in",
  wo_status_draft: "Draft",
  wo_status_sent: "Sent to client",
  wo_status_partially_approved: "Partly approved",
  wo_status_fully_approved: "Approved",
  wo_status_declined: "Declined",
  wo_status_quoted: "Quote sent",
  wo_status_accepted: "Quote accepted",
  wo_status_in_progress: "Working",
  wo_status_done: "Done",
  wo_status_ready_to_deliver: "Ready to deliver",
  wo_status_delivered: "Delivered",
  payment: "Payment",
  mark_as_paid: "Mark as paid",
  confirm_mark_paid_body: "Mark the invoice for {0} as paid?",
  no_work_order_to_settle: "This job card has no work order to settle yet.",
  payment_unpaid: "Unpaid",
  payment_awaiting_cash: "Cash on handover",
  payment_paid: "Paid",
  dashboard_admin_hint: "Every garage of this merchant, today and the work still ahead",
  garages_by_load: "Garages",
  garages_by_load_hint: "busiest first — open one to work on its day",
  no_garages: "No garages yet",
  overdue: "Late",
  overdue_hint: "past promised delivery",
  overdue_deliveries: "Past promised delivery",
  overdue_deliveries_hint: "promised back and still here",
  no_overdue: "Nothing is late",
  no_overdue_hint: "Every car still here is inside its promised date",
  col_appointments: "Appointments",
  col_in_bay: "In the bay",
  col_handover: "Handover",
  garage_load: "On the plate",
  garage_load_hint: "appointments and cars in the bay",
  staff_short: "staff",
  no_rating: "no ratings",
  open_garage: "Open this garage",
  q_short_pendingAppointments: "Pending",
  q_short_acceptedAppointments: "Accepted",
  q_short_openJobCards: "Open",
  q_short_awaitingApproval: "Awaiting",
  q_short_inProgressJobCards: "Working",
  q_short_unpaid: "Unpaid",
  q_short_readyToDeliver: "Ready",
  q_short_delivered: "Delivered",
  dashboard_unavailable: "The dashboard could not be loaded",
  dashboard_unavailable_hint: "The api did not answer for this garage. Check that it is running and up to date, then try again.",
  retry: "Try again",
  start_service: "Start service",
  start_service_hint: "Receive the car and open its job card",
  new_job_card: "New job card",
  new_job_card_hint: "Receive this vehicle into the garage",
  job_card_received_by: "Received by",
  job_card_received_by_hint: "The member of staff taking the car in",
  job_card_notes: "Drop-off notes",
  job_card_notes_hint: "What the customer said when handing the car over",
  job_card_mileage_hint: "Odometer reading on arrival",
  job_card_last_mileage: "Last recorded: {0} km{1}",
  job_card_mileage_lower_warning: "Lower than the last reading of {0} km",
  job_card_created: "Job card opened",
  booking_not_found: "This appointment could not be found",
  no_workers_hint: "Add staff to this garage before opening a job card",
  open_job_card: "Open job card",
  dashboard_pick_garage_hint: "Choose a garage above to see its appointments, job cards and shortcuts",

  // ── work order run ───────────────────────────────
  wo_status_label: "Work order status",
  wo_type_priority: "Priority repairs",
  wo_type_optional: "Optional repairs",
  wo_type_service: "Services",
  wo_item_pending: "Pending",
  wo_item_approved: "Approved",
  wo_item_rejected: "Rejected",
  work_order: "Work order",
  work_order_not_found: "This work order could not be found",
  back: "Back",
  mechanic_note: "Mechanic note",
  mechanic_note_hint: "Internal note for the garage team — the client never sees this…",
  save_note: "Save note",
  note_saved: "Note saved",
  work_items: "Work items",
  no_items_yet: "No items yet. Add what the inspection found.",
  add_item: "Add item",
  edit_item: "Edit item",
  remove_item: "Remove item",
  add_sub_item: "Add sub-item",
  add_choice_option: "Add option",
  add_choices: "Offer a choice",
  client_picks_one: "The client picks exactly one",
  choose_one: "Choose one",
  option: "Option",
  picked: "Picked",
  auto_approved: "Auto",
  parent_item: "Parent item",
  top_level_item: "— Top-level item —",
  item_type: "Type",
  service_part_name: "Service / part name",
  brand_name: "Brand name",
  estimated_cost: "Estimated cost",
  selling_price: "Selling price",
  cost_price: "Cost price",
  cost_price_short: "Cost: {0}",
  estimated_total: "Estimated total",
  total: "Total",
  client_note: "Client note",
  item_name_required: "A name is required",
  item_added: "Item added",
  items_added: "Items added",
  from_garage_services: "From garage services",
  no_garage_services: "This garage has no services set up yet.",
  no_sub_services: "No sub-services under this service yet.",
  no_price_set: "No price",
  add_selected: "Add selected",
  item_updated: "Item updated",
  item_removed: "Item removed",
  confirm_remove_item: "Remove this item?",
  item_photos: "Photos",
  photo_before: "Before",
  photo_after: "After",
  photo_add: "Add photo",
  photo_replace: "Replace",
  photo_none: "No photo",
  photo_uploaded: "Photo uploaded",
  photo_removed: "Photo removed",
  confirm_remove_photo: "Remove this photo?",
  photos_after_start_only: "Photos can be added once the work has started",
  messages: "Messages",
  message_client: "Message the client",
  no_messages: "No messages yet",
  reply_placeholder: "Write to the client…",
  send: "Send",
  reply_sent: "Message sent",
  close: "Close",
  about_this_item: "About this item",
  delivery_promised: "Promised to the client",
  delivery_promised_to: "Promised to the client — {0}",
  delivery_overdue: "Overdue",
  delivery_due_today: "Due today",
  delivery_date: "Delivery date and time",
  delivery_required: "Pick the date you promise the car back",
  delivery_day: "Delivery day",
  delivery_time: "Delivery time",
  delivery_time_required: "Pick a time the garage is open",
  delivery_pick_day_first: "Pick a day to see the times it can be collected",
  change_date: "Change date",
  delivery_updated: "Delivery date updated",
  assign: "Assign",
  change: "Change",
  assign_workers: "Assign this job",
  assign_workers_hint: "Whoever is on the job — you can hand it over later",
  assign_later: "Assign later",
  assignees_saved: "Job assigned",
  no_workers_to_assign: "This garage has no staff to assign",
  assign_before_starting: "Assign the job before starting it",
  garage_hours: "Garage hours",
  garage_break: "Break",
  send_to_customer: "Send to customer",
  confirm_send_to_customer: "Send this report to the customer for review?",
  work_order_sent: "Sent to the customer",
  waiting_client_review: "Waiting for the customer to review and confirm the report.",
  send_final_quote: "Send final quote",
  services: "Services",
  services_cost: "Services cost",
  services_cost_hint: "What the garage charges for the work itself. The customer sees it on the final quote.",
  services_cost_required: "Enter the services cost to send the final quote",
  services_cost_positive: "The services cost must be greater than 0",
  quote_sent: "Final quote sent to the customer",
  resend_for_review: "Send back for review",
  confirm_resend: "Send the report back? The customer keeps the choices they made and can change them before confirming again.",
  resent_for_review: "Sent back to the customer",
  waiting_client_accept: "Final quote sent. Waiting for the customer to accept it.",
  recall_quote: "Send back for review",
  confirm_recall_quote: "The customer won't see this final quote anymore. Change the price, date or assigned worker, then send it again when you're ready.",
  quote_recalled: "Quote pulled back — make your changes and send it again.",
  start_work: "Start work",
  work_started: "Work started",
  mark_as_done: "Mark as done",
  confirm_finish: "Mark this job as done?",
  work_finished: "Work completed",
  ready_to_deliver: "Ready to deliver",
  confirm_ready_to_deliver: "Park this car up for collection?",
  marked_ready: "Parked up for collection",
  awaiting_pickup: "The car is parked up and waiting for its owner.",
  mark_delivered: "Mark delivered",
  vehicle_delivered: "Vehicle handed over",
  work_order_delivered_note: "The customer has collected the vehicle. This job is closed.",
  work_order_declined_note: "The customer turned down every item, so this report is closed.",
  payment_summary: "Invoice",
  parts_total: "Parts and repairs",
  labor_total: "Labor",
  net_total: "Total due",
  cash_due_hint: "The customer chose to pay cash at the counter",
  confirm_cash_collected: "Confirm cash collected",
  confirm_cash_collected_body: "Confirm you have taken {0} in cash?",
  payment_confirmed: "Payment confirmed",
  settle_invoice_first: "Settle the invoice before handing the vehicle over",
  confirm: "Confirm",
  // work order lead steps and the job card's actions, as in the app
  approve_for_work: "Approve for work",
  approve_for_work_hint: "List the parts this job needs. The mechanics tick each one off as it reaches them, then start the work.",
  work_approved: "Work approved for the mechanics",
  assign_mechanics_first: "Assign mechanics first",
  assign_mechanics_first_hint: "Nobody is on this job yet. Pick the mechanics who will do the work, then approve it.",
  assign_mechanics: "Assign mechanics",
  unpriced_items_title: "Items without a price",
  unpriced_items_message: "{0} item(s) have no price yet:",
  unpriced_items_hint: "The customer will see them without a price.",
  send_anyway: "Send anyway",
  waiting_for_mechanic_start: "Approved — waiting for the mechanic to tick the parts and start",
  edit_parts_list: "Edit parts list",
  parts_list: "Parts list",
  parts_progress: "{0} of {1} in hand",
  no_parts_needed: "No parts needed for this job",
  part_name: "Part",
  part_qty: "Qty",
  add_part: "Add part",
  remove_part: "Remove part",
  confirm_remove_part: "Take this part off the list?",
  part_removed: "Part removed",
  requested_by: "Asked for by {0}",
  for_task: "For {0}",
  tasks_progress: "{0} of {1} tasks done",
  tasks_progress_hint: "Each mechanic marks their own tasks done in the app; the last one finishes the job.",
  final_check_ready: "Final inspection to be done",
  waiting_final_check: "Every task is done — check the car, then tell the customer it is ready",
  by_author: "By {0}",
  mechanic: "Mechanic",
  no_mechanic_assigned: "No mechanic",
  hours_needed: "Hours needed",
  hours_short: "{0} h",
  warranty: "Warranty",
  no_warranty: "No warranty",
  months_count: "{0} months",
  task_done: "Done",
  waiting_for_part: "Waiting for a part",
  send_to_inspect: "Send to inspect",
  inspectors: "Inspectors",
  choose_inspectors: "Choose the mechanics to inspect the car",
  no_mechanics_on_staff: "This garage has no mechanics on its staff",
  inspectors_assigned: "Sent to inspect",
  close_job_card: "Close job card",
  confirm_close_job_card: "Close this job card? The car is handed back and its work order is closed.",
  job_card_closed_done: "Job card closed",
  create_work_order: "Create work order",
  work_order_issues: "Work order — {0} of {1} approved",
  previous_visits: "Previous visits",
  no_issues_recorded: "No issues recorded",
  confirm_remove_attachment: "Remove this attachment from the job card?",
  attachment_removed: "Attachment removed",
  photo_uploaded_card: "Attachment added",
  report_monthly: "Monthly Report",
  report_cars_received: "Cars received",
  report_cars_fixed: "Cars fixed",
  report_tasks: "Tasks",
  report_tasks_done: "tasks done",
  report_plate: "Plate",
  report_vehicle: "Vehicle",
  report_total: "Total",
  report_cars: "cars",
};

export default lang;
